import React from 'react';
import './header.css';
import banner from './../../why_banner.png';

function Header() {
    return (
        <header className="header">
            <a href="http://joshalmostt.com/"><img className="header-image" src={banner} /></a>
            <h1>
                <a href="http://joshalmostt.com/" className="header-text">Josh Almostt</a>
            </h1>
        </header>
    )
}

export default Header;